import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for XML sitemap section
 * @param {Array} sitemaps - The sitemaps array
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (sitemaps) => {
  if (!sitemaps || sitemaps?.length === 0) {
    return 'No sitemap found in your robots.txt.';
  }
  return null;
};

/**
 * Transforms the sitemaps_validity criteria from WooRank API response
 * @param {Object} sitemapsCriteria - The sitemaps_validity criteria object from the API
 * @returns {Object} - Transformed XML sitemap data for React components
 */
export const transformXmlSitemap = (sitemapsCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!sitemapsCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No sitemap found in your robots.txt.',
      data: null,
    };
  }

  // Access nested data.sitemaps array (array of objects with url property)
  const dataObj = sitemapsCriteria?.data || {};
  const sitemaps = dataObj?.sitemaps || [];
  const wooRankStatus = sitemapsCriteria?.status || 'neutral';
  const importance = sitemapsCriteria?.importance || 0;
  const solvability = sitemapsCriteria?.solvability || 0;

  const isEmpty = !sitemaps || sitemaps?.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(sitemaps),
    data: isEmpty ? null : {
      sitemaps: (sitemaps || []).map((item) => ({
        url: item?.url || '',
      })),
    },
  };
};

export default transformXmlSitemap;

